import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const ntfy = defineConnector({
  identifier: "ntfy",
  name: "ntfy",
  tagLine: "Simple pub-sub notification service",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Enter your ntfy server URL",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://ntfy.sh",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText:
            "The base URL of your ntfy server. Use https://ntfy.sh for the public instance.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "markdown",
          content:
            "If your ntfy server requires authentication, provide an access token. Generate one with `ntfy token add`.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/v1/health`,
  },
});
